import { FieldValue } from '@/form/FormProvider.tsx';
import { isNil } from 'ramda';
import { education_banlist } from '@/form/fields/EmailInput/education_banlist.ts';

export const isEducationEmail = (value: FieldValue): boolean => {
  if (isNil(value.raw)) {
    return false;
  }
  for (const banned of education_banlist) {
    if (`${value.raw}`.endsWith(banned)) {
      return true;
    }
  }
  return false;
};
